import React, { useState,  useRef } from 'react';
import { ChevronLeft, ChevronRight, Copy } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function MintDetail() {
    const [selectedDevice, setSelectedDevice] = useState('Mobile');
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);
  
    const handleVideoClick = () => {
      if (videoRef.current) {
        videoRef.current.play();
        setIsPlaying(true);
      }
    };
  
    return (
      <div className="flex flex-col md:flex-row min-h-screen bg-gradient-to-tr from-gray-100 to-gray-200 p-4 gap-4 mt-14 overflow-hidden">
        {/* Left Sidebar */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="w-full md:w-64 bg-white rounded-2xl shadow-lg p-6 flex flex-col gap-6"
        >
          <div>
            <h1 className="text-2xl font-bold text-gray-800 mb-1">Coke Upsize</h1>
            <p className="text-sm text-blue-500 mb-2">ID: 235756</p>
            <button className="text-sm text-blue-500 hover:underline">Switch to previous version</button>
          </div>
  
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="bg-gradient-to-r from-blue-500 to-purple-500 text-white p-4 rounded-xl shadow-md"
          >
            <h3 className="font-semibold mb-2 truncate">Coke Upsize_Coke_upsize...</h3>
            <div className="text-xs space-y-1">
              <p>Ad dimension: 300x600</p>
              <p>Ad type: Banner - Javascript tag</p>
            </div>
          </motion.div>
        </motion.div>
  
        {/* Center Content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="flex-1 flex flex-col gap-4"
        >
          {/* Header */}
          <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
              Coke Upsize_Coke_upsize_300x600_prod_300x600
              <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600" />
            </h2>
            <div className="flex items-center gap-2">
              {['Mobile', 'Desktop'].map((device) => (
                <button
                  key={device}
                  className={`px-3 py-1 rounded-full text-xs transition-all ${
                    selectedDevice === device
                      ? 'bg-purple-500 text-white'
                      : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                  }`}
                  onClick={() => setSelectedDevice(device)}
                >
                  {device}
                </button>
              ))}
            </div>
          </div>
  
          {/* Navigation */}
          <div className="bg-white rounded-2xl shadow-lg p-4 flex items-center justify-between">
            <motion.button whileHover={{ scale: 1.05 }} className="flex items-center gap-2 text-gray-500 hover:text-gray-700">
              <ChevronLeft className="h-4 w-4" />
              Prev Ad
            </motion.button>
            <motion.button whileHover={{ scale: 1.05 }} className="flex items-center gap-2 text-gray-500 hover:text-gray-700">
              Next Ad
              <ChevronRight className="h-4 w-4" />
            </motion.button>
          </div>
  
          {/* Ad Preview Area */}
          <div className="flex-1 bg-white rounded-2xl shadow-lg p-4 md:p-8 flex items-center justify-center relative overflow-auto">
            {/* Navigation Arrows */}
            <motion.button
              whileHover={{ scale: 1.1 }}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-400 hover:text-gray-600 bg-white px-2 py-1 rounded-full shadow-md text-sm"
            >
              <ChevronLeft className="h-4 w-4" />
              Prev Ad
            </motion.button>
  
            <motion.button
              whileHover={{ scale: 1.1 }}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 flex items-center gap-1 text-gray-400 hover:text-gray-600 bg-white px-2 py-1 rounded-full shadow-md text-sm"
            >
              Next Ad
              <ChevronRight className="h-4 w-4" />
            </motion.button>
  
            {/* Device Frame with Hover Animation */}
            <AnimatePresence mode="wait">
              {selectedDevice === 'Mobile' ? (
                <motion.div
                  key="mobile"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.4 }}
                  className="relative max-w-xs mx-auto"
                >
                  <div className="absolute -inset-2 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-3xl"></div>
  
                  <div className="bg-gray-200 rounded-3xl p-3 shadow-lg">
                    <div className="bg-white rounded-2xl p-2 shadow-inner">
                      <div
                        className="w-[250px] h-[500px] bg-black rounded-xl overflow-hidden relative group cursor-pointer"
                        onClick={handleVideoClick}
                      >
                        <video ref={videoRef} src="https://eskimi-creatives.com/host/Johnnie_Walker/JW_FY25_video/video_300600.mp4" muted
              playsInline
              loop className="w-full h-full object-cover" />
                        {/* Hover Overlay */}
                        {!isPlaying && (
                          <motion.div
                            initial={{ opacity: 0 }}
                            whileHover={{ opacity: 1 }}
                            className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-lg font-semibold"
                          >
                            Click to Play
                          </motion.div>
                        )}
                      </div>
                    </div>
                    <div className="w-24 h-1 bg-gray-400 rounded-full mx-auto mt-2"></div>
                  </div>
                </motion.div>
              ) : (
                <motion.div
                  key="desktop"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.4 }}
                  className="relative max-w-xs mx-auto"
                >
                  <div className="absolute -inset-2 border-2 border-dashed border-blue-400 bg-blue-50 bg-opacity-50 rounded-xl"></div>
  
                  <div className="bg-white rounded-xl shadow-lg p-4">
                    <div
                      className="w-[250px] h-[500px] bg-black rounded overflow-hidden relative group cursor-pointer"
                      onClick={handleVideoClick}
                    >
                      <video ref={videoRef} src="https://eskimi-creatives.com/host/Johnnie_Walker/JW_FY25_video/video_300600.mp4"  muted
              playsInline
              loop className="w-full h-full object-cover" />
                      {/* Hover Overlay */}
                      {!isPlaying && (
                        <motion.div
                          initial={{ opacity: 0 }}
                          whileHover={{ opacity: 1 }}
                          className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-lg font-semibold"
                        >
                          Click to Play
                        </motion.div>
                      )}
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
  
        {/* Right Sidebar */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="w-full md:w-80 bg-white rounded-2xl shadow-lg p-6 flex flex-col justify-between"
        >
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-6">Creative Details</h3>
  
            <div className="space-y-4">
              <div>
                <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Dimension:</h4>
                <p className="text-gray-800">300x600</p>
              </div>
  
              <div>
                <h4 className="text-sm font-medium text-gray-600 mb-1">Ad Type:</h4>
                <p className="text-gray-800">Banner - Javascript tag</p>
              </div>
  
              <div>
                <h4 className="text-sm font-medium text-gray-600 mb-1">Creative ID:</h4>
                <p className="text-gray-800">1526050</p>
              </div>
  
              <button className="text-blue-500 hover:underline text-sm mt-4">
                Open Full-Size Creative
              </button>
            </div>
          </div>
  
          <div className="flex justify-center mt-6">
            <div className="w-32 h-32 bg-gray-100 border-2 border-gray-300 p-2 flex items-center justify-center">
              <span className="text-gray-500">QR Code</span>
            </div>
          </div>
        </motion.div>
      </div>
    );
  }